<div oui-dialog-title>
  {{ title }}

  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content class="dialog-content">
  <span>{{ description }}</span>

  <oui-textarea
    label="Motif"
    [control]="motifControl"
    [errors]="motifErrors"
    [hint]="motifHint">
  </oui-textarea>

  @if (isLoading()) {
    <div class="loading-container">
      <oui-loading></oui-loading>
    </div>
  }
</oui-dialog-content>

<oui-dialog-actions class="dialog-actions">
  <oui-button type="text" [disabled]="isLoading()" oui-dialog-close>Annuler</oui-button>
  <oui-button
    [type]="form.valid ? 'contained' : 'outlined'"
    [disabled]="isLoading()"
    (click)="activateHabilitation()"
    >{{ confirmLabel }}</oui-button
  >
</oui-dialog-actions>
